// extracted by mini-css-extract-plugin
module.exports = {"searchPage":"ie_if","body":"ie_g1","ctaContainer":"ie_ig","cta":"ie_ih"};